import {
  OBTENER_RUTAS,
  OBTENER_RUTAS_EXITO,
  OBTENER_RUTAS_ERROR,
  COMENZAR_EDICION_RUTA,
  RUTA_EDITADO_EXITO,
  RUTA_EDITADO_ERROR,
  RESET_EDICION_RUTA,
} from "../../redux/types";
import clienteAxios from "../../config/axios";
import { handlerError } from "../../utils/handlerError";

// Función que descarga las rutas de la base de datos
export function obtenerRutasAction(dias, conductorId) {
  return async (dispatch) => {
    dispatch(descargarRutas());
    await clienteAxios
      .get(`/rutas/buscar?dias=${dias}&conductor=${conductorId}`)
      .then((respuesta) => {
        dispatch(descargaRutasExitosa(respuesta.data));
      })
      .catch((err) => {
        dispatch(descargaRutasError(handlerError(err)));
      });
  };
}

const descargarRutas = () => ({
  type: OBTENER_RUTAS,
  payload: true,
});

const descargaRutasExitosa = (rutas) => ({
  type: OBTENER_RUTAS_EXITO,
  payload: rutas,
});

const descargaRutasError = (error) => ({
  type: OBTENER_RUTAS_ERROR,
  payload: error,
});


export function editarRutaAction(ruta) {
  return async (dispatch) => {
    dispatch(editarRuta());
    await clienteAxios
      .patch(`/rutas/updateruta`, ruta)
      .then((respuesta) => {
        dispatch(editarRutaExito(respuesta.data));
      })
      .catch((err) => {
        dispatch(editarRutaError(handlerError(err)));
      });
  };
}

const editarRuta = () => ({
  type: COMENZAR_EDICION_RUTA,
  payload: true,
});

const editarRutaExito = (pedido) => ({
  type: RUTA_EDITADO_EXITO,
  payload: pedido,
});

const editarRutaError = (error) => ({
  type: RUTA_EDITADO_ERROR,
  payload: error,
});

export function resetEditarRutaAction() {
  return async (dispatch) => {
    dispatch(resetEditarRuta());
  };
}

const resetEditarRuta = () => ({
  type: RESET_EDICION_RUTA,
  payload: true,
});